<template>
    
    <v-container>
        <img alt="M4C logo" src="@/assets/footer-car.png" style="position:absolute;bottom:0;right:0;width:30%;height:auto;">
    
        <v-layout row v-if="error">
            <v-flex xs12 sm6 offset-sm3>
                <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
            </v-flex>
        </v-layout>
        <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
                <v-card>
                    <v-card-text>
                        <v-container>
                            <h2 class="headline pb-2">Sign in</h2>
                            <form @submit.prevent="onLogin">
                                <v-layout row>
                                    <v-flex xs12>
                                        <v-text-field
                                        name="email"
                                        id="email"
                                        label="Email"
                                        v-model="email"
                                        type="email"
                                        required></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs12>
                                        <v-text-field
                                        name="password"
                                        id="password"
                                        label="Password"
                                        v-model="password"
                                        type="password"
                                        required></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs12>
                                        <v-btn type="submit" :disabled="loading" :loading="loading">
                                            Log in
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </form>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    data() {
        return {
            email: '',
            password: '',
            confirmPassword: ''
        }
    },
    computed: {
        user() {
            return this.$store.getters.user
        },
        error() {
            return this.$store.getters.error
        },
        loading() {
            return this.$store.getters.loading
        }
    },
    watch: {
        user(value) {
            // when new user signs up or is logged in
            if(value !== null && value !== undefined) {
                this.$router.push('/')
            }
        }
    },
    methods: {
        onLogin(){
            let payload = { email: this.email, password: this.password }
            this.$store.dispatch('login', payload)
        },
        onDismissed () {
            this.$store.dispatch('clearError')
        }
    }
}
</script>
